import React, { memo, useRef, useCallback, useMemo } from 'react'

import {
  Icon,
  Search,
  Button,
  FileFormat,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import FileFormatContent from 'Pods/SearchPage/Shared/FileFormatContent/FileFormatContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { addFileType, clearFileTypes, removeFileType } from 'Pods/SearchPage/Store/actions/fileTypes'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

const prefixIcon = <Icon notSpaced svgComponent={FileFormat} color="dark" size="small" />
const SEARCH_FOCUS_DELAY = 300

function FileFormats() {
  const translate = useTranslate()

  const searchRef = useRef(null)
  const fileTypes = useSearchPageStore(state => state.fileTypes)

  const handleReset = useCallback(() => {
    clearFileTypes()
  }, [])

  const handleFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      addFileType(value)
    } else {
      removeFileType(value)
    }
  }, [])

  const onOpenChange = useCallback((isOpen) => {
    if (isOpen && searchRef.current) {
      setTimeout(() => {
        searchRef.current?.focus()
      }, SEARCH_FOCUS_DELAY)
    }
  }, [])

  const textInputProps = useMemo(() => ({
    leadIcon: <Icon notSpaced svgComponent={Search} color="dark" />,
    textInputClassName: 'filter-wrapper__search-input',
    ref: searchRef,
  }), [])

  const content = useMemo(() => (
    <div className="file-format-filter__wrapper">
      <div className="file-format-filter__scrollable">
        <FileFormatContent
          fileTypes={fileTypes}
          onFilterChange={handleFilterChange}
          textInputProps={textInputProps}
          limit={0}
        />
      </div>
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={fileTypes.length === 0}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </div>
  ), [fileTypes, handleFilterChange, handleReset, textInputProps, translate])

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.file_format.title')}
      prefixIcon={prefixIcon}
      content={content}
      onOpenChange={onOpenChange}
      hasSelectedAnyFilters={!!fileTypes.length}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(FileFormats)
